import { Component, EventEmitter, Output } from '@angular/core';
import { ApiService } from 'src/app/core/api.service';
import * as AmdocsContentConstants from '../../../content.constants';

@Component({
  selector: 'app-learning-popup',
  templateUrl: './learning-popup.component.html',
  styleUrls: ['./learning-popup.component.scss']
})
export class LearningPopupComponent{

  @Output() onCloseCallback: EventEmitter<any> = new EventEmitter();
  public amdocsContentConstant: any = AmdocsContentConstants?.default;
  constructor(
    private apiService: ApiService
  ) { }

  close(): void {
    this.apiService.updateLearningPopupStatus(true).subscribe();
    this.onCloseCallback.emit();
  }
}
